import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import App from './App';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import { ThemeProvider } from './context/Theme';

const RootApp = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const getActiveTabFromPath = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path === '/query') return 'query';
    if (path === '/transfer') return 'transfer';
    if (path === '/claude-docs') return 'claude-docs';
    if (path === '/pricing') return 'pricing';
    return 'home';
  };

  const activeTab = getActiveTabFromPath();
  const isHomePage = location.pathname === '/';

  return (
    <ThemeProvider>
      <div className={`app-container ${isHomePage ? 'app-container--home' : ''}`}>
        {!isHomePage && (
          <Sidebar 
            activeTab={activeTab}
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />
        )}
        <main className={`main-content ${isHomePage ? 'main-content--home' : ''}`}>
          {!isHomePage && <TopBar />}
          {!isHomePage && (
            <button 
              className="mobile-menu-btn" 
              onClick={() => setSidebarOpen(true)}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          )}
          <App />
        </main>
      </div>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <RootApp />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
